<template>
	<div>
		<Page :total="total" show-sizer @on-change="updatePage" @on-page-size-change='updateSize'  show-total show-elevator/>
	</div>
</template>

<script>
	export default{
		name:'my-page',
		data(){
			return {
				
			}
		},
		props:["total"],
		methods:{
			updatePage(page){//页码改变的回调，返回改变后的页码
				this.$emit('updatePage',page);
			},
			updateSize(size){//切换每页条数时的回调，返回切换后的每页条数
				this.$emit('updateSize',size);
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/comm/page.vue